export function LoadingPlanCard () {
  return (
    <div className='animate-pulse'>
      <div className='w-full min-w-[450px] h-[181px] rounded-2xl border border-gray-200 bg-gray-200 mt-4 p-4' />
    </div>
  )
}

LoadingPlanCard.displayName = 'SmartBudget.PlanCard.Loading'
